import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import user from './user';
import organization from './organization';
import analytics from './analytics';
import shortenLink from './shortenLink';
import report from './report';
import notification from './notification';

export default combineReducers({
	router: routerReducer,
	user,
	organization,
	analytics,
	shortenLink,
	report,
	notification,
});
